import type { StripeElementLocale } from '@stripe/stripe-js';

/**
 * The language Stripe's own part of the checkout (payment method names, card
 * fields, card errors) should use: the language the fan chose on the fan page.
 * Without it Stripe follows the phone's language, so a Finnish page showed an
 * English card form on an English phone. Stripe translates these texts itself.
 */
const SUPPORTED: ReadonlySet<string> = new Set<StripeElementLocale>([
  'ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'en-AU', 'en-CA', 'en-NZ', 'en-GB', 'es', 'es-ES', 'et', 'fi',
  'fil', 'fr', 'fr-CA', 'fr-FR', 'he', 'hu', 'hr', 'id', 'it', 'it-IT', 'ja', 'ko', 'lt', 'lv', 'ms', 'mt',
  'nb', 'nl', 'no', 'pl', 'pt', 'pt-BR', 'ro', 'ru', 'sk', 'sl', 'sv', 'th', 'tr', 'vi', 'zh', 'zh-HK', 'zh-TW',
]);

/** A Stripe Elements locale for the page language; 'auto' (the phone's language) when Stripe has none for it. */
export function stripeElementsLocale(pageLocale: string | null | undefined): StripeElementLocale {
  const raw = (pageLocale ?? '').trim();
  if (!raw) return 'auto';
  const [lang, region] = raw.split(/[-_]/);
  const base = lang.toLowerCase();
  const regional = region ? `${base}-${region.toUpperCase()}` : null;
  if (regional && SUPPORTED.has(regional)) return regional as StripeElementLocale;
  if (SUPPORTED.has(base)) return base as StripeElementLocale;
  return 'auto';
}
